import React, { Component, ReactNode } from 'react';
import './Login.scss';
import { AuthLayout } from '../layouts/auth-layout/AuthLayout';
import Button from 'react-bootstrap/Button';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { AuthHelper } from '../helpers/AuthHelper';
import { ERouterPath } from '../features/router/ERouterPath';

class Logout extends Component<RouteComponentProps<any>> {
  constructor(props: RouteComponentProps<any>) {
    super(props);

    AuthHelper.signOut();
  }

  handleClick = (): void => {
    this.props.history.push(ERouterPath.login);
  };

  render(): ReactNode {
    return (
      <AuthLayout className="logout">
        <div className="logout__alert">Je bent nu uitgelogd.</div>
        <Button className="logout__btn" onClick={this.handleClick}>Inloggen</Button>
      </AuthLayout>
    );
  }
}

export default withRouter(Logout);
